var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.275391 7.5H5.72951V24H0.275391V7.5ZM20.5858 7.6935C20.5279 7.6755 20.473 7.656 20.412 7.6395C20.3388 7.6232 20.2651 7.60919 20.191 7.5975C19.8689 7.53271 19.5411 7.50004 19.2124 7.5C16.0326 7.5 14.0159 9.7755 13.3512 10.6545V7.5H7.89713V24H13.3512V15C13.3512 15 17.4731 9.351 19.2124 13.5V24H24.6649V12.8655C24.6627 11.6807 24.261 10.5301 23.5228 9.59416C22.7846 8.65818 21.7516 7.9897 20.5858 7.6935Z",
    fill: "#0A4B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.943 5.25C4.41628 5.25 5.61061 4.07475 5.61061 2.625C5.61061 1.17525 4.41628 0 2.943 0C1.46972 0 0.275391 1.17525 0.275391 2.625C0.275391 4.07475 1.46972 5.25 2.943 5.25Z",
    fill: "#0A4B65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3896,
    height: 24,
    fill: "white",
    transform: "translate(0.275391)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.307f0b6e7932fc16361d86b9872901d8.svg";
export { ForwardRef as ReactComponent };